require('./calcalist_site_calcalistPaywallLoginComponenta.less');
import { HyperLinkBuilder } from "../../../commonComponents/inline/hyperLink";
import { LinkTargetProperties } from "../../../../global/components/linkSettings/interfaces"
import { useState, useEffect } from "react"
import { getCurrentUser } from "../../../../global/paywall/paywallUtils";
import { AuthLogOut } from "../../../../global/paywall/authOperations";
import { getNewlinkTargetProperties, getNewWindowOpenTargetProperties } from "../../../widgetsUtils"

interface CalcalistUser {
    displayName: string
}
export interface CalcalistMenuItem {
    id: string
    name: string
    link: string
    catId: string
    url: string
    targetLink?: LinkTargetProperties
}

interface CalcalistLoginProps {
    menuItems?: CalcalistMenuItem[]
    subscribeBtnLink?: { link: string, linkTarget: LinkTargetProperties };
}
export const CalcalistPaywallLoginComponenta = (props: CalcalistLoginProps) => {
    const [user, setUser] = useState<CalcalistUser>(null);
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const { menuItems, subscribeBtnLink } = props;
    const defaultLinkTarget = getNewlinkTargetProperties()
    const blankLinkTarget = getNewWindowOpenTargetProperties()

    useEffect(() => {
        const currentUser = getCurrentUser()
        setUser(currentUser);
    }, [])


    const getUsernameFromEmail = (email: string): string => {
        return email.split('@')[0];
    }

    const handleToggleMenu = () => {
        setIsMenuVisible(!isMenuVisible);
    }

    const getUserLabel = () => {
        let label = '';
        if (user) {
            label = user.displayName;
            if (user.displayName.includes('@')) {
                label = getUsernameFromEmail(user.displayName);
            }
            return <div onClick={handleToggleMenu}>שלום, <span className="bold displayName">{label}</span></div>;
        }
    };

    const handleDisconectUser = async () => {
        try {
            await AuthLogOut();
            window.location.reload();
        } catch (error) {
            console.log(error);
        }
    }

    const handlePopup = () => {
        setIsPopupVisible(!isPopupVisible);
        if (isPopupVisible) {
            document.body.style.setProperty('overflow-y', 'auto', 'important');
        } else {
            document.body.style.setProperty('overflow-y', 'hidden', 'important');
        }
        document.body.classList.toggle('popup');
    }

    return (
        <div className="CalcalistPaywallLoginComponenta">
            <ul className="header-list">
                <li className="header-item">
                    <HyperLinkBuilder className="header-link red-text" href="https://www.calcalist.co.il/redmail" linkTarget={defaultLinkTarget}>
                        <div alt="RedMail" className="header-icon redmail"></div>
                        <div>דואר האדום</div>
                    </HyperLinkBuilder>
                </li>
                <li className="header-item">
                    <HyperLinkBuilder className="header-link" href="https://www.calcalist.co.il/conferences" linkTarget={blankLinkTarget}>
                        <div alt="Calendar" className="header-icon conference"></div>
                        <div>ועידות</div>
                    </HyperLinkBuilder>
                </li>
                <li className="header-item newspaper">
                    <HyperLinkBuilder className="header-link" href={subscribeBtnLink.link} linkTarget={subscribeBtnLink.linkTarget}>
                        <div>המהדורה הדיגיטלית</div>
                    </HyperLinkBuilder>
                </li>
                {user &&
                    <>
                        <li className="separator"><span></span></li>
                        <li className="header-item">
                            <a href="#" className="header-link user">
                                {getUserLabel()}
                            </a>
                        </li>
                    </>
                }

            </ ul>
            {isMenuVisible &&
                <div className="CalcalistPaywallLoginComponentaUserMenu">
                    {menuItems && menuItems.length > 0 && menuItems.map((item, index) => {
                        if (!item.name) {
                            return null;
                        }
                        return  <HyperLinkBuilder className="menu-item" href={item.link} linkTarget={item.targetLink}>
                                    {item.name}
                                </HyperLinkBuilder>
                    })}
                    <div onClick={handlePopup} className="menu-item">התנתקות</div>
                </div>}

            {isPopupVisible &&
                <>
                    <div className="CalcalistPaywallLoginComponentaOverlay"></div>
                    <div className="CalcalistPaywallLoginComponentaPopup">
                        <div className="inner-container">
                            <div className="logo-container">
                                <div className="digital-edidion-label">המהדורה הדיגיטלית</div>
                                <div className="disconnect-logo"></div>
                            </div>
                            <div className="text">
                                האם אתם בטוחים שברצונכם
                                להתנתק מהמשתמש שלכם?
                        </div>
                            <div className="buttons-contianer">
                                <div onClick={handlePopup} className="button back">חזרה</div>
                                <div onClick={handleDisconectUser} className="button action">כן, התנתק</div>
                            </div>
                        </div>
                    </div>
                </>
            }

        </div>
    )
}
CalcalistPaywallLoginComponenta.siteScriptName = "CalcalistPaywallLoginComponenta"

